import type { CurrencyCode } from './regional';

export type OrgCurrencySource = {
  profileCurrency?: CurrencyCode | null;
  detailsCurrency?: CurrencyCode | null;
  detailsLoading: boolean;
};

export type OrgCurrency = {
  currency: CurrencyCode | undefined;
  isLoading: boolean;
};

/**
 * Organization currency for money formatting.
 *
 * A profile code wins, including while organization details are still
 * loading. A details code is used only after that request finishes.
 */
export const getOrgCurrency = ({
  profileCurrency,
  detailsCurrency,
  detailsLoading,
}: OrgCurrencySource): OrgCurrency => {
  if (profileCurrency) return { currency: profileCurrency, isLoading: false };

  if (!detailsLoading && detailsCurrency) {
    return { currency: detailsCurrency, isLoading: false };
  }

  return { currency: undefined, isLoading: detailsLoading };
};
